import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
import { UserContextProvider } from "./../UserContextProvider";
import { UserConfigContextProvider } from "./../UserConfig";
import { Home } from "./../Home";
import { Header } from "./../Header";
import { Settings } from "./../Settings";
import { LoginPrompt } from "./../LoginPrompt";
import { GoogleAnalytics } from "./../GoogleAnalytics";
import { UserGuiding } from "./../UserGuiding";
import { GuideStepper } from "./../Guide";
import { HeaderAgencySetup } from "../Header/HeaderAgencySetup";
import { AgencySetup, Setup } from "../Setup";
import { SetupUserContextProvider } from "../UserContextProvider/SetupUserContextProvider";
import { NoTenantUserContextProvider } from "../UserContextProvider/NoTenantUserContextProvider";
import { NoTenantHome } from "../Home/NoTenantHome";
import AgencyOnboardingContainer from "../Setup/AgencyOnboardingContainer";
import UnavailableFeature from "../UnavailableFeature/UnavailableFeature";
import { HeaderForAgent } from "../Header/HeaderForAgent";
import UnavailableApplication from "../UnavailableApplication/UnavailableApplication";
import { FullStoryProvider } from "../FullStory";
import PostEnrollmentManager from "../Setup/PostEnrollmentManager";

export function Content() {
  return (
    <Switch>
      <Route exact path="/">
        <Redirect to="/login/prompt" />
      </Route>
      <Route path="/provider/siaa">
        <Redirect to="/home?sso=siaa" />
      </Route>
      <Route path="/login">
        <LoginPrompt />
      </Route>
      <Route path="/feature-unavailable">
        <HeaderForAgent />
        <UnavailableFeature />
      </Route>
      <Route path="/application-unavailable">
        <HeaderForAgent />
        <UnavailableApplication />
      </Route>
      <Route path="/agency-setup">
        <SetupUserContextProvider>
          <FullStoryProvider>
            <AgencySetup>
              <HeaderAgencySetup />
              <AgencyOnboardingContainer />
            </AgencySetup>
          </FullStoryProvider>
        </SetupUserContextProvider>
      </Route>
      <Route path="/agencyIQ">
        <Switch>
          <Route path="/agencyIQ/waitingArea">
            <NoTenantUserContextProvider>
              <FullStoryProvider>
                <Header />
                <PostEnrollmentManager/>
              </FullStoryProvider>
            </NoTenantUserContextProvider>
          </Route>
          <Route path="/agencyIQ">
            <NoTenantUserContextProvider>
              <FullStoryProvider>
                <Header />
                <NoTenantHome />
              </FullStoryProvider>
            </NoTenantUserContextProvider>
          </Route>
        </Switch>
      </Route>
      <Route path="/home">
        <UserContextProvider>
          <UserConfigContextProvider>
            <GoogleAnalytics>
              <FullStoryProvider>
                <UserGuiding />
                <Switch>
                  <Route path="/home/settings">
                    <Header
                      centerContent={<GuideStepper activeStep={0} />}
                      title="Getting Started"
                    />
                    <Settings />
                  </Route>
                  <Route path="/home">
                    <Header />
                    <Home />
                  </Route>
                </Switch>
              </FullStoryProvider>
            </GoogleAnalytics>
          </UserConfigContextProvider>
        </UserContextProvider>
      </Route>
    </Switch>
  );
}
